
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'kn-validation-messages',
    props: {
        vComp: {
            type: Object,
            required: true
        },
        /*  If you need to add specific parametrs for translation which are not part of validator parameters. Use it rarly. */
        additionalTranslateParams: {
            type: Object,
            default: () => {}
        },
        /* This is used if there is a need for specific key for some param. Use it rarly. */
        specificTranslateKeys: Object,
        defaultMessageTranslateBasePath: {
            type: String,
            default: process.env.VUE_APP_VALIDATION_MESSAGES_BASE_KEY
        }
    }
})
